import axios from 'axios';
import { deleteMethodProps } from 'src/types/axios.types';

const deleteRequest = ({
  url,
  loader,
  successFunction,
  errorFunction,
  customHeader,
}: deleteMethodProps) => {
  if (loader) {
    loader(true);
  }
  axios
    .delete(url, customHeader)
    .then((res) => {
      if (successFunction) {
        successFunction(res);
      }
    })
    .catch((error) => {
      // const { response } = error;
      // if (response) {
      //   if (response.data.StatusCode === 401) {
      //     // unAuthorizedException(error, dispatch, postRequest, [url, payload, loader, successFunction, errorFunction])
      //     return;
      //   }
      // }
      if (errorFunction) {
        errorFunction(error);
      }
    })
    .finally(() => {
      if (loader) {
        loader(false);
      }
    });
};

export default deleteRequest;
